module.exports = __webpack_public_path__ + "static/media/play-resign.5f163c51.png";